// extracted by mini-css-extract-plugin
export default {"form":"AccountSecurity_form__9kqgw","input":"AccountSecurity_input__SAumi"};